import Config from "../Configs";

export const customeLog = (message: string) => {
  if (Config.isDebug) {
    //
  }
};
